var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInnercircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "56.199 47 85.6 92.517",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddii_9075_66765",
    x: 2.59922,
    y: 0.0799978,
    width: 233,
    height: 270.52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.68
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.427167 0 0 0 0 0 0 0 0 0 0.970833 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9075_66765"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 40.2,
    dy: 80.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.02 0 0 0 0 0 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_9075_66765",
    result: "effect2_dropShadow_9075_66765"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.575 0 0 0 0 0.575 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_9075_66765",
    result: "effect3_dropShadow_9075_66765"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_9075_66765",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.7,
    dy: 13.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.319637 0 0 0 0 0.089375 0 0 0 0 0.975 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect4_innerShadow_9075_66765"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.34
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_innerShadow_9075_66765",
    result: "effect5_innerShadow_9075_66765"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9075_66765",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.594 51.6184) rotate(110.973) scale(88.0068 88.0068)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2484",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9075_66765",
    x1: 132.117,
    y1: 50.6958,
    x2: 118.73,
    y2: 68.1535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D1A8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5581,
    stopColor: "#7240C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5888,
    stopColor: "#7240C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7551,
    stopColor: "#7240C6",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddii_9075_66765)",
    transform: "matrix(1, 0, 0, 1, 0, 2.917482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.799 93.8C141.799 117.438 122.637 136.6 98.9992 136.6C75.3614 136.6 56.1992 117.438 56.1992 93.8C56.1992 70.1622 75.3614 51 98.9992 51C122.637 51 141.799 70.1622 141.799 93.8Z",
    fill: "#1B211C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.799 93.8C141.799 117.438 122.637 136.6 98.9992 136.6C75.3614 136.6 56.1992 117.438 56.1992 93.8C56.1992 70.1622 75.3614 51 98.9992 51C122.637 51 141.799 70.1622 141.799 93.8Z",
    fill: "url(#paint0_radial_9075_66765)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135 47L129.634 69.5845L114.515 57.9904L135 47Z",
    fill: "url(#paint2_linear_9075_66765)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnercircle);
export default __webpack_public_path__ + "static/media/innercircle.3e3290f9732ea42927b13d8709540666.svg";
export { ForwardRef as ReactComponent };